/**
 * HomepageHero Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders HomepageHero Block
 */

import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { SVBTypography } from '@svb/svb-react-components';
import Loading from "@svb/api-loading-component/dist/components/index";
// import { Utils } from '@svb/api-content-component';
import { getFileContent } from '../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import {SVBCard} from '@svb/svb-react-components';
import { slugCreator } from "../../core/useStore";


/**
  * HomepageHero
  * @param content: url of the HomepageHero content
  * @param backgroundImg: url for the backgrond image for this section
  * @returns HomepageHero block 
*/

const HomepageHero = ({ datatestid, testMockContent, content, backgroundImg }) => {
    const [loading, setLoading] = useState(true);
    // const token = localStorage.getItem('token');
    const { regenTokenandBrowse } = browseAPIhandler();
    const getHeroContent = datatestid ? testMockContent : getFileContent(`${content}`, regenTokenandBrowse);
    useEffect(() => {
        if (getHeroContent.type === 'success') {
            setLoading(false)
        }
    }, [getHeroContent.response])

    if (loading) {
        return <Loading />
    }
    // overrides HomepageHeroCardSection tag from markdown and renders Homepage Hero Card wrapper element
    const HomepageHeroCardSection = ({ children }) => (
        <>
            <div className="homepage_hero__separation mb-5"></div>
            <div className="cards row justify-content-between">
                {children}
            </div>
        </>
    );
    // overrides Card tag from markdown and renders Homepage Hero Cards
    const HeroCard = ({ link, cardIcon, title, description }) => {
        const cardTestid = slugCreator("card-"+title);
        const cardOptions = {
            cardClickable: true
        }
        return(
        <div className="col-md-4 col-sm-12 d-flex justify-content-center mb-4">           
            <SVBCard cardIcon={cardIcon}
                            title={title}
                            description={description}
                            link={link}
                            cardOptions={cardOptions}
                            lazyLoading={true}
                            datatestid={{card: cardTestid, learnMore: ''}}
                            />
        </div>
        );
    };
   

    const bg_img = backgroundImg ? { backgroundImage: `linear-gradient(90.26deg, rgba(0, 0, 0, 0.56) 37.16%, rgba(0, 0, 0, 0) 67.26%),url(${backgroundImg})` } : {};

    return (
        <section data-testid={datatestid} id="homepage-hero" className="hero-section" style={bg_img}>
            <div className="container svb-container-fixed col-md-9 col-sm-12">
                <h1 hidden>SVB API Developer Portal | Homepage</h1>
                <Markdown  options={{
                    overrides: {
                        h1: {
                            component: SVBTypography,
                            props: {
                                type: "heading-large",
                                variant: "header-1 pb-3"
                            }
                        },
                        h2: {
                            component: SVBTypography,
                            props: {
                                type: "heading-medium",
                                variant: "header-2"
                            }
                        },
                        HomepageHeroCardSection: {
                            component: HomepageHeroCardSection
                        },
                        Card: {
                            component: HeroCard,
                        }
                    }
                }} >{getHeroContent.response}</Markdown>
                </div>
        </section>

    );
}
export default HomepageHero;